 (function () {
    const PACKAGE_PROTECTION_VARIANT_ID = 55771410858313;
    const SWITCH_SELECTOR = '.packprotection';
    const SAFETY_UNLOCK_MS = 15000;
    const OPT_OUT_KEY = 'pakiet_opt_out';

    const ON_CART_PAGE = location.pathname.replace(/[/]+$/, '') === '/cart';
    let changedByUs = false;
    let chain = Promise.resolve();
    function reloadIfCartPage() { if (ON_CART_PAGE && changedByUs) { changedByUs = false; location.reload(); } }

    let previousNormalItemCount = 0;
    let hasInitialized = false;
    let activeOperations = 0;
    let safetyUnlockTimer = null;

    /* Auto-add on page load only when we can remember an opt-out; without storage keep the add-to-cart-only behaviour. */
    function autoAddAllowed() {
      try { return sessionStorage.getItem(OPT_OUT_KEY) !== '1'; } catch (e) { return false; }
    }

    function rememberChoice(isOn) {
      try { if (isOn) sessionStorage.removeItem(OPT_OUT_KEY); else sessionStorage.setItem(OPT_OUT_KEY, '1'); } catch (e) {}
    }

    function isProcessing() {
      return activeOperations > 0;
    }

    /* Disable the toggle while a cart action + price update is running,
       so it cannot be switched again until everything is finished. */
    function applyLockState() {
      const locked = isProcessing();
      document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => {
        s.disabled = locked;
        s.classList.toggle('syncing', locked);
        const label = s.closest('.switch');
        if (label) label.classList.toggle('switch--disabled', locked);
      });
    }

    function beginOperation() {
      activeOperations += 1;
      applyLockState();

      if (safetyUnlockTimer) clearTimeout(safetyUnlockTimer);
      safetyUnlockTimer = setTimeout(() => {
        safetyUnlockTimer = null;
        activeOperations = 0;
        applyLockState();
      }, SAFETY_UNLOCK_MS);
    }

    function endOperation() {
      activeOperations = Math.max(0, activeOperations - 1);

      if (activeOperations === 0 && safetyUnlockTimer) {
        clearTimeout(safetyUnlockTimer);
        safetyUnlockTimer = null;
      }

      applyLockState();
    }

    function fetchCart() {
      return fetch('/cart.js').then((response) => response.json());
    }

    function cartHasProtection(cart) {
      return cart.items.some((item) => item.variant_id === PACKAGE_PROTECTION_VARIANT_ID);
    }

    function normalItemQuantity(cart) {
      return cart.items.reduce((sum, item) => {
        return item.variant_id === PACKAGE_PROTECTION_VARIANT_ID ? sum : sum + item.quantity;
      }, 0);
    }

    function updateToggleState(cart) {
      const on = cartHasProtection(cart);
      document.querySelectorAll(SWITCH_SELECTOR).forEach((t) => { t.checked = on; });
    }

    function refreshCartDrawer(cart) {
      const cartDrawer = document.querySelector('cart-drawer');
      const sectionWrapper = cartDrawer?.closest('[id^="shopify-section-"]');
      const sectionId = sectionWrapper?.id;

      if (!cartDrawer || !sectionId) {
        const countSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        const countLabel = document.querySelector('.cart-count-bubble span.visually-hidden');
        if (countSpan) countSpan.textContent = cart.item_count;
        if (countLabel) countLabel.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;
        applyLockState();
        return Promise.resolve();
      }

      return fetch(`${Shopify.routes.root}?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sectionElement = html.getElementById(sectionId);
          const newCartDrawerContent = sectionElement?.querySelector('cart-drawer');

          if (newCartDrawerContent) {
            cartDrawer.replaceChildren(...newCartDrawerContent.children);
          } else if (sectionElement) {
            cartDrawer.innerHTML = sectionElement.innerHTML;
          }

          cartDrawer.classList.toggle('drawer--center-body', cart.item_count === 0);
          const countSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
          const countLabel = document.querySelector('.cart-count-bubble span.visually-hidden');
          if (countSpan) countSpan.textContent = cart.item_count;
          if (countLabel) countLabel.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;

          /* Re-rendered section markup comes back enabled, so re-apply the lock. */
          applyLockState();
        });
    }

    function runCartUpdate() {
      return fetchCart()
        .then((cart) => {
          const normalQty = normalItemQuantity(cart);
          const hasProtection = cartHasProtection(cart);

          if (!hasInitialized) {
            hasInitialized = true;

            if (normalQty > 0 && !hasProtection && autoAddAllowed()) {
            changedByUs = true;
              return addPackageProtection()
                .then(fetchCart)
                .then((updatedCart) => {
                  updateToggleState(updatedCart);
                  previousNormalItemCount = normalItemQuantity(updatedCart);
                  return refreshCartDrawer(updatedCart);
                })
                .then(() => {
                  hideCheckoutLoader(); reloadIfCartPage();
                });
            }

            if (normalQty === 0 && hasProtection) {
              changedByUs = true;
              return removePackageProtection().then(fetchCart).then((c2) => {
                updateToggleState(c2);
                return refreshCartDrawer(c2);
              }).then(() => { hideCheckoutLoader(); reloadIfCartPage(); });
            }

            previousNormalItemCount = normalQty;
            updateToggleState(cart);
            return refreshCartDrawer(cart).then(() => {
              hideCheckoutLoader();
            });
          }

          if (normalQty === 0 && hasProtection) {
            changedByUs = true;
            return removePackageProtection()
              .then(fetchCart)
              .then((updatedCart) => {
                updateToggleState(updatedCart);
                previousNormalItemCount = normalItemQuantity(updatedCart);
                return refreshCartDrawer(updatedCart);
              })
              .then(() => {
                hideCheckoutLoader(); reloadIfCartPage();
              });
          }

          if (normalQty > previousNormalItemCount && !hasProtection && autoAddAllowed()) {
            changedByUs = true;
            return addPackageProtection()
              .then(fetchCart)
              .then((updatedCart) => {
                updateToggleState(updatedCart);
                previousNormalItemCount = normalItemQuantity(updatedCart);
                return refreshCartDrawer(updatedCart);
              })
              .then(() => {
                hideCheckoutLoader(); reloadIfCartPage();
              });
          }

          previousNormalItemCount = normalQty;
          updateToggleState(cart);

          return refreshCartDrawer(cart)
            .then(() => {
              hideCheckoutLoader();
            });
        })
        .catch((error) => {
          hideCheckoutLoader();
          console.error('Package protection update failed:', error);
        });
    }

    /* Keeps the toggle locked for the whole refresh cycle:
       cart action -> price recalculation -> drawer re-render. */
    function updateCartAndDrawer() {
      /* Serialised: two quick cart events never run at the same time (no double add, never qty 2). */
      chain = chain.then(() => {
        beginOperation();
        return runCartUpdate().then(endOperation, endOperation);
      });
      return chain;
    }

    function syncProtectionState() {
      return fetchCart().then((cart) => {
        updateToggleState(cart);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return cart;
      });
    }

    function showCheckoutLoader() {
      const priceSpan = document.querySelector('.cart-summary__row--total span:last-child');
      if (!priceSpan || priceSpan.dataset.loading) return;

      priceSpan.dataset.loading = "true";
      priceSpan.dataset.original = priceSpan.innerHTML;

      priceSpan.classList.add("loading-price");
      priceSpan.innerHTML = '<span class="price-loader"><span class="price-loader__dot"></span><span class="price-loader__dot"></span><span class="price-loader__dot"></span></span>';
    }

    function hideCheckoutLoader() {
      const priceSpan = document.querySelector('.cart-summary__row--total span:last-child');
      if (!priceSpan || !priceSpan.dataset.loading) return;

      priceSpan.innerHTML = priceSpan.dataset.original;
      priceSpan.classList.remove("loading-price");

      delete priceSpan.dataset.loading;
      delete priceSpan.dataset.original;
    }

    function addPackageProtection() {
      showCheckoutLoader();
      return fetchCart().then((cart) => {
        if (cartHasProtection(cart)) return null;
        const body = new URLSearchParams();
        body.append('id', PACKAGE_PROTECTION_VARIANT_ID);
        body.append('quantity', '1');
        return fetch('/cart/add.js', { method: 'POST', body: body }).then(response => response.json());
      })
        .then(syncProtectionState);
    }

    function removePackageProtection() {
      showCheckoutLoader();
      return fetchCart()
        .then((cart) => {
          const protectionItem = cart.items.find((item) => item.variant_id === PACKAGE_PROTECTION_VARIANT_ID);
          if (!protectionItem) {
            return cart;
          }

          const body = new URLSearchParams();
          body.append('id', protectionItem.key);
          body.append('quantity', '0');

          return fetch('/cart/change.js', {
            method: 'POST',
            body: body
          })
            .then(response => response.json());
        })
        .then(syncProtectionState);
    }

    function handleSwitchChange(evt) {
      evt.preventDefault();

      const switchElement = evt.target;

      /* Fallback guard: a change slipped through while an update is running. */
      if (isProcessing()) {
        switchElement.checked = !switchElement.checked;
        applyLockState();
        return;
      }

      const isTurningOn = switchElement.checked;
      rememberChoice(isTurningOn);
      changedByUs = true;

      document.querySelectorAll(SWITCH_SELECTOR).forEach(s => {
        s.checked = isTurningOn;
      });

      beginOperation();

      const request = isTurningOn
        ? addPackageProtection()
        : removePackageProtection();

      Promise.resolve(request)
        .then(() => {
          endOperation();
          reloadIfCartPage();
        })
        .catch((error) => {
          console.error('Protection toggle failed, reverting:', error);
          document.querySelectorAll(SWITCH_SELECTOR).forEach(s => {
            s.checked = !isTurningOn;
          });
          endOperation();
        });
    }

    function handleCartButtonClick() {
      setTimeout(updateCartAndDrawer, 100);
    }

    document.addEventListener('change', (evt) => {
      if (evt.target.classList && evt.target.classList.contains('packprotection')) {
        handleSwitchChange(evt);
      }
    });

    /* Swallow clicks on the toggle/label while an update is still running. */
    document.addEventListener('click', (evt) => {
      if (!isProcessing()) return;
      const target = evt.target;
      if (target.closest && (target.closest('.package-protection-btn') || target.closest('.switch'))) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }, true);

    document.addEventListener('click', (evt) => {
      if (evt.target.classList.contains('cart-remove-button') || evt.target.classList.contains('buy-buttons')) {
        handleCartButtonClick();
      }
    }, true);

    document.addEventListener('cart:change', updateCartAndDrawer);
    document.addEventListener('cart:refresh', updateCartAndDrawer);
    document.addEventListener('DOMContentLoaded', updateCartAndDrawer);
  })();
/* Header-teller telt alleen echte producten (de bescherming telt niet mee). */
(function () {
  var VID = 55771410858313, real = null;
  function fix() { if (real === null) return; document.querySelectorAll('cart-count').forEach(function (el) { if (el.textContent.trim() !== String(real)) el.textContent = real; }); }
  function upd() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { var p = 0; c.items.forEach(function (i) { if (i.variant_id === VID) p += i.quantity; }); real = c.item_count - p; fix(); }).catch(function () {}); }
  function watch() { document.querySelectorAll('cart-count').forEach(function (el) { if (el.__ppw) return; el.__ppw = 1; new MutationObserver(fix).observe(el, { childList: true, characterData: true, subtree: true }); }); }
  ['cart:change', 'cart:refresh', 'pageshow', 'DOMContentLoaded'].forEach(function (e) { document.addEventListener(e, function () { watch(); setTimeout(upd, 150); }); });
  watch(); upd();
})();
